import type { PlayerData } from '../../components/PlayersStats/PlayersStats.types';

const sortAssistPlayersData = (player1: PlayerData, player2: PlayerData) =>
  (player2.assists || 0) - (player1.assists || 0);

export default sortAssistPlayersData;
